import { EditProfileInputField } from './types';
import { createAction } from 'typesafe-actions';

export const INIT_PROFILE_EDIT_FIELD = 'INIT_PROFILE_EDIT_FIELD';
export const initProfileEditField = createAction(INIT_PROFILE_EDIT_FIELD)();

export const UPDATE_PROFILE_FIELD = 'UPDATE_PROFILE_FIELD';
export const updateProfileField = createAction(UPDATE_PROFILE_FIELD)<
  EditProfileInputField
>();
